import React, { Component } from "react";
import "./Header.css";
import { Link } from "react-router-dom";
const companyLogo = require("../../assets/icons/ibm_blacklogo.png");

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHome: true,
      isInspectr: false
    };
  }

  render() {
    return (
      <div className="nav-main-class">
        <div>
          <Link to="/">
            <img className="profile-icon-ibm" src={companyLogo} />
          </Link>
        </div>
        <div className="right-nav">
          <div className="dropdown">
            <div className="nav-1">Solutions</div>
            <div className="dropdown-content">
              <Link className="dropdown-item" to="/inspectr">
                <div className="each-dropdown-item">IoTVision</div>
              </Link>
              {/*<Link className="dropdown-item" to="/tracer">
                <div className="each-dropdown-item" >TraceR</div>
              </Link>*/}
            </div>
          </div>
          <Link to="/">
            <div className="nav-1">Home</div>
          </Link>
        </div>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// src/components/header/Header.js